import { Controller } from 'stimulus';

class ProjectsController extends Controller {
  connect() {
    this.modal = document.getElementById('projects-modal');

    if (!this.modal) {
      throw new Error('Modal is undefined #projects-modal');
    }

    this.modalBody = document.getElementById('projects-modal-body');
  }

  onOpen(event) {
    const { currentTarget } = event;
    const projectId = currentTarget.getAttribute('data-project-id');

    if (!projectId) {
      throw new Error('Could not find projectId on element');
    }

    $(this.modal).modal('show');

    this.setPopupContents();
    this.fetchPopupContents(projectId);
  }

  setPopupContents(contents = null) {
    if (!contents) {
      this.modalBody.innerHTML = `
        <div class="projects-modal__loading">
          <svg class="icon icon-spinner" aria-hidden="true"><use xlink:href="#icon-spinner"></use></svg>
        </div>
      `;
      return;
    }

    this.modalBody.innerHTML = contents;
  }

  fetchPopupContents(projectId) {
    $.post(`/api/project-modal/${projectId}`)
      .then((res) => {
        this.setPopupContents(res);
      })
      .catch((err) => {
        this.setPopupContents(err.responseText);
      });
  }
}

ProjectsController.targets = [
  //
];

export default ProjectsController;
